// --------------------------------------------------------------
// Created On: 2024-05-02
// Author: KC Willard
//
// Last Modified: 2025-07-10
// Modified By: Dimitra Weinstein
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import deepCopy from "./deepCopy";

// Return the cart item id of an item that has the same configuration as the item being passed in.
export default function findExistingCartItem(
  selectedCartItem: CartItem | QuoteCartItemShoppingCart,
  cartItems: (CartItem | QuoteCartItemShoppingCart)[]
): number | null {
  const cartItemsDeepCopy = deepCopy(cartItems);
  let foundItem = null;
  foundItem = cartItemsDeepCopy.find((cartItem) => {
    if (
      cartItem.units === "EA" &&
      cartItem.cartItemId !== selectedCartItem.cartItemId &&
      (impellerMatch(cartItem, selectedCartItem) || nonImpellerMatch(cartItem, selectedCartItem))
    ) {
      return cartItem;
    }
  });

  if (foundItem !== undefined) {
    return foundItem.cartItemId;
  } else {
    return null;
  }
}

// Function to see if two cart items have the same configuration on their impellers, if they have impellers.
function impellerMatch(
  cartItemA: CartItem | QuoteCartItemShoppingCart,
  cartItemB: CartItem | QuoteCartItemShoppingCart
): boolean {
  if (
    cartItemA.impellerAngle !== null &&
    cartItemA.impellerTrim !== null &&
    cartItemB.impellerAngle !== null &&
    cartItemB.impellerTrim !== null
  ) {
    if (
      cartItemA.partNumber === cartItemB.partNumber &&
      cartItemA.paintColorId === cartItemB.paintColorId &&
      parseFloat(cartItemA.impellerAngle) === parseFloat(cartItemB.impellerAngle) &&
      parseFloat(cartItemA.impellerTrim) === parseFloat(cartItemB.impellerTrim)
    ) {
      return true;
    }
  }
  return false;
}
// Function to see if two cart items that do not have impellers have the same configuration.
function nonImpellerMatch(
  cartItemA: CartItem | QuoteCartItemShoppingCart,
  cartItemB: CartItem | QuoteCartItemShoppingCart
): boolean {
  if (
    cartItemA.impellerAngle === null &&
    cartItemA.impellerTrim === null &&
    cartItemB.impellerAngle === null &&
    cartItemB.impellerTrim === null
  ) {
    if (cartItemA.partNumber === cartItemB.partNumber && cartItemA.paintColorId === cartItemB.paintColorId) {
      return true;
    }
  }
  return false;
}

interface CartItem {
  cartItemId: number;
  name: string;
  partId: number;
  partNumber: string;
  isPaintable: boolean;
  paintColorId: number | null;
  quantity: string;
  quantityIsValid: boolean;
  units: string;
  price: number | null;
  weight: number | null;
  impellerTrim: string | null;
  impellerTrimIsValid: boolean;
  impellerAngle: string | null;
  impellerAngleIsValid: boolean;
  dateAvailable: string | null;
}

interface QuoteCartItemShoppingCart {
  cartItemId: number;
  name: string; //Description of the part.
  partId: number;
  partNumber: string;
  isPaintable: boolean;
  paintColorId: number | null;
  quantity: string;
  quantityIsValid: boolean;
  units: string;
  price: number | null;
  weight: number | null;
  impellerTrim: string | null;
  impellerTrimIsValid: boolean;
  impellerAngle: string | null;
  impellerAngleIsValid: boolean;
  dateAvailable: string | null;
}
